import { useEffect, useState } from "react";
import axios from "axios";
import { Panel } from "@/components/admin/ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputClass = "mt-1 w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm dark:border-white/15 dark:bg-white/5 dark:text-white";
const labelClass = "text-xs font-bold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500";

// Optionally links to an existing org team member (auto-fills name/email) instead of
// creating a separate contact record - still fully editable/overridable afterward.
export const PrimaryContactSection = ({ form, onChange }) => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/org/team`, { withCredentials: true })
      .then((res) => setMembers((res.data?.members || []).filter((m) => !m.is_deactivated)))
      .catch(() => setMembers([]));
  }, []);

  const handlePick = (userId) => {
    if (!userId) {
      onChange({ primary_contact_user_id: "" });
      return;
    }
    const member = members.find((m) => m.user_id === userId);
    onChange({
      primary_contact_user_id: userId,
      primary_contact: member?.name || form.primary_contact,
      primary_contact_email: member?.email || form.primary_contact_email,
    });
  };

  return (
    <Panel title="Primary Contact" subtitle="Your organization's main business/operational contact." testId="org-settings-primary-contact">
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="sm:col-span-2">
          <label className={labelClass}>Select from Team (optional)</label>
          <select
            value={form.primary_contact_user_id || ""}
            onChange={(e) => handlePick(e.target.value)}
            data-testid="org-settings-primary-contact-member-select"
            className={`${inputClass} font-semibold`}
          >
            <option value="">— Enter manually —</option>
            {members.map((m) => <option key={m.user_id} value={m.user_id}>{m.name} ({m.email})</option>)}
          </select>
        </div>
        <div>
          <label className={labelClass}>Contact Name</label>
          <input value={form.primary_contact || ""} onChange={(e) => onChange({ primary_contact: e.target.value })} data-testid="org-settings-primary-contact-name-input" className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Title / Role</label>
          <input value={form.primary_contact_title || ""} onChange={(e) => onChange({ primary_contact_title: e.target.value })} data-testid="org-settings-primary-contact-title-input" className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Email</label>
          <input type="email" value={form.primary_contact_email || ""} onChange={(e) => onChange({ primary_contact_email: e.target.value })} data-testid="org-settings-primary-contact-email-input" className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Phone</label>
          <input value={form.primary_contact_phone || ""} onChange={(e) => onChange({ primary_contact_phone: e.target.value })} data-testid="org-settings-primary-contact-phone-input" className={inputClass} />
        </div>
      </div>
    </Panel>
  );
};
